export default "__VITE_ASSET__CnlIz51h__"